<template>
  <div>
    <div
      class="grid md:grid-cols-2 lg:w-5/5 gap-4 mt-4 mx-auto"
      v-if="enableCustomerPortal"
    >
      <div
        class="my-account-left lg:px-16 px-8 pb-4 lg:pb-12 md:my-account-border my-account-bottom"
      >
        <h2>Login</h2>
        <p>
          Log in to view and manage your account or create your account if you
          dont have one
        </p>
        <div class="my-1">
          <a
            href="#"
            class="button button-white"
            @click="onSignIn()"
            >Log in</a
          >
        </div>
        <div class="my-1">
          <a
            href="#"
            class="button button-white"
            @click="onSignUp()"
            >Create account</a
          >
        </div>
      </div>
      <div class="my-account-right lg:px-12 px-8">
        <h2>Or don't</h2>
        <p>
          Quickly pay a bill or subscribe to auto payments so you don't have to
          remember
        </p>
        <div v-if="showForm">
          <div v-if="errors.length" class="red">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="(error, index) in errors" :key="index" class="red">
                {{ error }}
              </li>
            </ul>
          </div>
          <form class="lg:w-2/3 mx-auto">
            <div class="relative">
              <input
                type="text"
                placeholder="Account Number *"
                tabindex="1"
                class="w-full"
                v-model="accountNo"
              />
              <a
                href="#"
                class="help form-icon"
                @click.stop.prevent="toggleToast"
                tabindex="-1"
                >?</a
              >
              <Toast v-if="showToast" @hideToast="toggleToast" type="info">
                <h3>How to find your customer number:</h3>
                <p>
                  You can locate your customer number at the top of your Spring
                  Green invoice.
                </p>
              </Toast>
            </div>
            <div class="grid grid-cols-3 gap-4">
              <div class="grid col-span-2">
                <input
                  type="text"
                  placeholder="Last Name *"
                  tabindex="2"
                  class="w-full"
                  v-model="lastName"
                />
              </div>
              <div>
                <input
                  type="text"
                  placeholder="Zipcode *"
                  tabindex="3"
                  class="w-full"
                  v-model="zipCode"
                  maxlength="5"
                />
              </div>
            </div>
            <input
              type="submit"
              class="button w-300 mt-4"
              value="Submit"
              :disabled="isFindingAccount"
              @click.stop.prevent="findAccount()"
            />
          </form>
        </div>
        <div v-else class="grid md:grid-cols-1 lg:w-4/5 gap-4 mt-4 mx-auto">
          <div
            class="my-account-left-sub lg:px-8 px-4 md:my-account-border my-account-bottom"
          >
            <div class="bg-grey rounded p-6">
              <h2>Pay Your Bill</h2>
              <p v-if="billPayEnabled">
                If you would like to pay a one time bill online using your
                credit card, you can use our online bill pay system.
              </p>
              <p v-else>
                Bill Pay service is currently unavailable.
                Please try again at a later time...
              </p>
              <div
                v-if="billPayEnabled"
                @click="hideMyAccount()"
              >
                <NuxtLink
                  to="/pay-a-bill/"
                  class="button"
                  @click.stop="hideMyAccount()"
                >
                  Online bill pay
                </NuxtLink>
              </div>
            </div>
          </div>
          <div
            class="my-account-right lg:px-8 px-4 md:my-account-border my-account-bottom"
            v-if="!isAutoPay"
          >
            <div class="bg-grey rounded p-6">
              <h2>Auto Pay Your Bill</h2>
              <p v-if="autoPayEnabled">
                Auto Pay makes paying your bill quick, easy, and hassle-free.
                Your credit card is automatically billed after every service.
              </p>
              <p v-else>
                Auto Pay service is currently unavailable.
                Please try again at a later time...
              </p>
              <div
                v-if="autoPayEnabled"
                @click="hideMyAccount()"
              >
                <NuxtLink
                  to="/autopay/"
                  class="button"
                  @click.stop="hideMyAccount()"
                >
                  Enroll now
                </NuxtLink>
              </div>
            </div>
          </div>
          <div
            class="my-account-right lg:px-8 px-4 md:my-account-border my-account-bottom"
            v-else
          >
            <div class="bg-grey rounded p-6">
              <h2>Add A New Card</h2>
              <p>Already enrolled in auto pay. Add a new card for Auto Pay</p>
              <div @click="hideMyAccount()">
                <NuxtLink to="/autopay/" class="button">Add A New Card</NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <h2>Welcome to your Spring Green account</h2>
      <div v-if="showForm">
        <div v-if="errors.length" class="red">
          <b>Please correct the following error(s):</b>
          <ul>
            <li v-for="(error, index) in errors" :key="index" class="red">
              {{ error }}
            </li>
          </ul>
        </div>
        <form class="w-2/3 mx-auto">
          <div class="relative">
            <input
              type="text"
              placeholder="Account Number *"
              class="w-full"
              v-model="accountNo"
            />
            <a href="#" class="help form-icon" @click.stop.prevent="toggleToast"
              >?</a
            >
          </div>
          <div class="grid grid-cols-3 gap-4">
            <div class="grid col-span-2">
              <input
                type="text"
                placeholder="Last Name *"
                class="w-full"
                v-model="lastName"
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="Zipcode *"
                class="w-full"
                v-model="zipCode"
              />
            </div>
          </div>
          <input
            type="submit"
            class="button w-300 mt-4"
            value="Submit"
            :disabled="isFindingAccount"
            @click.stop.prevent="findAccount()"
          />
        </form>
        <Toast v-if="showToast" @hideToast="toggleToast" type="info">
          <h3>How to find your customer number:</h3>
          <p>
            You can locate your customer number at the top of your Spring Green
            invoice.
          </p>
        </Toast>
      </div>
      <div v-else class="grid md:grid-cols-2 lg:w-4/5 gap-4 mt-4 mx-auto">
        <div
          class="my-account-left-sub lg:px-16 px-8 md:my-account-border my-account-bottom"
        >
          <div class="bg-grey rounded p-6 ml-8">
            <h2>Pay Your Bill</h2>
            <p>
              If you would like to pay a one time bill online using your credit
              card, you can use our online bill pay system.
            </p>
            <div @click="hideMyAccount()">
              <NuxtLink
                to="/pay-a-bill/"
                class="button"
                @click.stop="hideMyAccount()"
                >Online bill pay</NuxtLink
              >
            </div>
          </div>
        </div>
        <div
          class="my-account-right lg:px-16 px-8 md:my-account-border my-account-bottom"
          v-if="!isAutoPay"
        >
          <div class="bg-grey rounded p-6 ml-8">
            <h2>Auto Pay Your Bill</h2>
            <p>
              Auto Pay makes paying your bill quick, easy, and hassle-free. Your
              credit card is automatically billed after every service.
            </p>
            <div @click="hideMyAccount()">
              <NuxtLink
                to="/autopay/"
                class="button"
                @click.stop="hideMyAccount()"
                >Enroll now</NuxtLink
              >
            </div>
          </div>
        </div>
        <div
          class="my-account-right lg:px-16 px-8 md:my-account-border my-account-bottom"
          v-else
        >
          <div class="bg-grey rounded p-6 ml-8">
            <h2>Add A New Card</h2>
            <p>Already enrolled in auto pay. Add a new card for Auto Pay</p>
            <div @click="hideMyAccount()">
              <NuxtLink
                to="/autopay/"
                class="button"
                @click.stop="hideMyAccount()"
                >Add A New Card</NuxtLink
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from 'vuex';
import type { Store } from 'vuex/types/index.js';
import type State from '~/domains/store/State';

const { $customers, $sg, $userContext, $payments } = useNuxtApp();

// Reactive state
const accountNo = ref('');
const lastName = ref('');
const zipCode = ref('');
const showForm = ref(true);
const showToast = ref(false);
const enableCustomerPortal = ref(true);
const errors = ref<string[]>([]);
const isFindingAccount = ref(false);

// Vuex store
const store: Store<State> = useStore();

// Computed properties
const billPayEnabled = computed(() => $payments.getEnabledPayTypes().includes("billPay"));
const autoPayEnabled = computed(() => $payments.getEnabledPayTypes().includes("autoPay"));
const isAutoPay = computed(() => store.state.persistedState?.customer?.contactPreferences?.autoPay ?? false);

const emit = defineEmits(['hideMyAccount']);

// Auth
const { signIn } = useAuth()
const onSignIn = async () => {
  await signIn("azure-ad-b2c", { callbackUrl: '/auth' });
};
const onSignUp = async () => {
  await signIn("azure-ad-b2c-signup", { callbackUrl: '/auth' });
}

// Methods
const findAccount = async () => {
  if (isFindingAccount.value) {
    return;
  }

  try {
    isFindingAccount.value = true;
    errors.value = [];

    const customer = await $customers.getCustomerByInfo(accountNo.value.trim(), lastName.value.trim(), zipCode.value.trim());

    if (customer?.error || !customer?.cust_No) {
      throw new Error("We were unable to find an account with that information. Please try again.");
    }

    if (customer.sqldbid !== store.state.persistedState.sqldbid || customer.cust_No !== store.state.persistedState.cust_No) {
      const franchiseInfo = await $sg.getApiData(`Companies/SG/Franchise/SQLDBID/${customer.sqldbid}`);
      await $userContext.refresh({
        clearState: true,
        stateUpdate: {
          branchCode: franchiseInfo.branchNo,
          custNo: customer.cust_No,
        },
        refresh: new Set(["ALL"]),
      });
    }

    showForm.value = false;
  } catch (ex) {
    console.error(ex);
    errors.value.push(ex.message);
  } finally {
    isFindingAccount.value = false;
  }
};

const toggleToast = () => {
  showToast.value = !showToast.value;
};

const hideMyAccount = () => {
  emit("hideMyAccount");
};

// Lifecycle hook
onMounted(async () => {
  const portalStatus = await $sg.getOctoberData('customerportal/status');
  enableCustomerPortal.value = portalStatus == 1;
});
</script>



<style scoped>
.card {
  padding: 25px;
  background: #f7f7f7;
  text-align: left;
  border-radius: 26px;
}

.card a.button {
  display: inline-block;
  width: 100%;
  text-align: center;
}

.form-icon {
  position: absolute;
  right: -40px;
  top: 15px;
}

.help {
  border-radius: 30px;
  border: 1px solid #517185;
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: #517185;
  font-weight: 600;
}

.w-300 {
  width: 300px;
}

.my-account-left {
  border-right: 1px solid #ddd;
}

.my-account-left-sub {
  padding-bottom: 40px;
}

.my-account-right li {
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .my-account-left {
    border-bottom: 1px solid #ddd;
    border-right: none !important;
  }

  .form-icon {
    top: 0;
    background: #fff;
    right: -32px;
  }

  .my-account-right .toast {
    position: absolute;
    top: 0;
    right: 0;
    left: auto;
    max-width: 350px;
    width: 100%;
  }
}

a[disabled] {
  pointer-events: none;
  background-color: grey;
}

input[disabled] {
  pointer-events: none;
  background-color: grey;
}
</style>
